<template>
  <div class="more-places-list">
    <!-- <div class="header">
      <div class="header-label t-title sm mb-m">
        <span class="loading-text-more-places" v-if="isLoading">Loading more places</span>
        <span v-else>More places</span>
      </div>
    </div> -->
    <div>
      <!-- <MorePlacesCard
        title="Best in the City"
        subTitle="18 Places"
        :buttonType="ButtonTypes.primary"
        buttonLabel="Explore"
        :isLoading="false"
        selectRoute="/abcde"
        :images="[
          'https://images.pexels.com/photos/268533/pexels-photo-268533.jpeg?cs=srgb&dl=pexels-pixabay-268533.jpg&fm=jpg',
          'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCfemubkMy3OXPsQWsXKD2YR-XbuipzEYn6e4jr8r7AQ&s',
        ]"
      /> -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
// import MorePlacesCard from '@common/card/more-places-card';
import {ButtonTypes} from '@common/button/button.vue';

Vue.use(VueCompositionAPI);

export default {
  name: 'AmexMorePlaces',
  components: {
    // MorePlacesCard
  },
  props: {
    isLoading: {
      type: Boolean,
    },
  },
  data() {
    return {
      ButtonTypes,
    };
  },
  setup(/*props, {emit, root}*/) {
    return {};
  },
};
</script>

<style scoped lang="scss">
.more-places-list {
  max-width: var(--page-container-width, 1260px);
  margin: 40px auto;
  --flight-pic-size: 140px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.header-label {
  padding-top: 80px;
}

.loading-text-more-places {
  position: relative;
  left: 30px;
}

.loading-text-more-places + span {
  text-transform: lowercase;
}

.loading-text-more-places:before {
  content: '';
  background: url(data:image/png+xml;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANiSURBVHgB3VVNa5xVFD7n3PvOO5NJMklRhjYzaZUgLtqiG0uYESK4cSHoQly46Eb/gH9C6FLc+gfEhS4EEcFYSwN+ILaIIFohQ2rGtKmTZpJ5P+45fd5+Jp1pPrprD7yf997znPucc55L9KQb7zlaP10tlWqvi4WXAvELwtbAgjKRXDHTrrEtpp2lLx4LwM+0XhPhD9hsktg8mXg8I2aqGIbJKMLlmbmrrJ+kyxc/H+XHjfoZzbTOOsfvMVkJISAIERLMNRMjgVPyZuTg3BPZNKa84WtNCRudpX0BSsfbb8Pjm1J8WOHeimvb1H4Wpu/V7Dc22sJIHd9VPAsQ+JG2m2hMhZud7x5JUWW23Qqm75Mx2CkWkg/Ovj6yvflZt3upvyuSxvxMLPIOKX3Iwt4AAmAnKme3Vn74aiRAudH6CPw+a8wCOpyw+3TQOX+e9rBKs/WuGn18m7ZindrGWL9y+saNb3u7KIoa7TNmdgbRGKIHO/Zl0rnwDe1j+Ubndzc9O12spTt5qaZR9ifycbkYlwdT7aQ4zvGSWbBeqvkFOqClbnAOMfX5bj4Q5Fv3xu4DAPooIigAcmb7g1Z+vE4HtSu/9Ih5CZcD6Q40vTwEgFqZwC3DhMxElumQxmqXkTdUNqMn6egwQAg5xnJUQsbBAh3SBmTnEuZ6wnQMz8YQAArzmrDk2Gamgt0c1jbjuOqy0ng0Fu38vZOilSIHGixl5edpbi6mA9uCp/Gk2s/Ea9r31BsFkNo/aoocWF7IQjl/Zp4Oao1kMhYXU2CvESqpvJEOAWTjtUtOfFFqBf/BcjlVOjH/4n6+a7Pt6ZKL6ljlYw/n2/i5o+sfaNH6X0FqTQDYCfCFXABEuekmmqrliU3aWkt3eV5Y8OVkppF6PcZBERIKHalMqvk1Wl9J7k0bkutys/Uquvgksh7UQg6tyaF2W87sqsZyPck0lEjH1Fw1QlvlitJWK3onpPlglVZ/Xdvpb0hN0frLMnUc50moo6IUghSgMahwHsO+jkCrpyJxlUA4BYob5CdyTAOzNbr60+rD/kaeB9pb/jeanLuJ1NeA5ElYUWHKDk0EZHg1Z9BN6Cd2m6Pu/6bOxf9G+dr7yCys/spz3jnICI+7SOKCjsC0Kab/p9u0TqfiLi0u5vTU2i2RZn5qNPtV/wAAAABJRU5ErkJggg==)
    no-repeat;
  background-position: 50%;
  -webkit-animation: spin-data-v-1c84b83a infinite linear 1s;
  animation: spin-data-v-1c84b83a infinite linear 1s;
  position: absolute;
  top: 0.1em;
  left: -1.2em;
  width: 1em;
  height: 1em;
}
</style>
